module.exports = __webpack_public_path__ + "static/media/notifications-permissions.1132c9d5.png";